module.exports = __webpack_public_path__ + "img/logo-kamitech-dark.2af0c777.svg";